import {
  NetActivity,
  NetFront,
  NetReward,
  NetUserAgent,
  NetUserIDRisk,
} from "@/constants/netEvent";
import { reqPost } from "@/service/clientRequest";
import { GetPidInfoReq, GetPidInfoRsp } from "@/types/swagger/front";
import {
  AgencyDayCommissionRecordReq,
  AgencyDayCommissionRecordRsp,
  AgencyFriendVipReq,
  AgencyFriendVipRsp,
  AgencyLockUserReq,
  AgencyLockUserRsp,
  AgencyReceiveRewardReq,
  AgencyRewardListReq,
  AgencyRewardListRsp,
  AgencyRewardRsp,
  AgencySummaryRsp,
  AgencyTeamCommissionData,
  GetAgentRewardRedDotDataRsp,
  GetAgentShareConfigRsp,
  GetAppSentRewardAmountAnd40UserGotRecordReq,
  GetAppSentRewardAmountAnd40UserGotRecordResp,
  GetUserStatCombineForAgentActivityReq,
  GetUserStatCombineForAgentActivityResp,
  GetVipPrivilegesActivityReq,
} from "@/types/swagger/userAgent";
import { GetUserKycStatusRsp } from "@/types/swagger/userIDRisk";

export const useGetAgencyRewardDetail = (data: {}) => {
  return reqPost<{}, AgencyRewardRsp>(
    data,
    NetUserAgent.mod,
    NetUserAgent.AgencyRewardDetail,
    true,
  );
};

export const useGetAppSentRewardAmountAnd40UserGotRecord = (
  data: GetAppSentRewardAmountAnd40UserGotRecordReq,
) => {
  return reqPost<
    GetAppSentRewardAmountAnd40UserGotRecordReq,
    GetAppSentRewardAmountAnd40UserGotRecordResp
  >(
    data,
    NetUserAgent.mod,
    NetUserAgent.GetAppSentRewardAmountAnd40UserGotRecord,
  );
};
export const useGetUserStatCombineForAgentActivity = (
  data: GetUserStatCombineForAgentActivityReq,
) => {
  return reqPost<
    GetUserStatCombineForAgentActivityReq,
    GetUserStatCombineForAgentActivityResp
  >(
    data,
    NetUserAgent.mod,
    NetUserAgent.GetUserStatCombineForAgentActivity,
    true,
  );
};
export const useAgencySummary = (data: {}) => {
  return reqPost<{}, AgencySummaryRsp>(
    data,
    NetUserAgent.mod,
    NetUserAgent.AgencySummary,
    true,
  );
};
export const useGetPidInfo = (data: GetPidInfoReq) => {
  return reqPost<GetPidInfoReq, GetPidInfoRsp>(
    data,
    NetFront.mod,
    NetFront.GetPidInfo,
  );
};
export const useDoAgentActive = (data: {}) => {
  return reqPost<{}, AgencySummaryRsp>(
    data,
    NetActivity.mod,
    NetActivity.DoAgentActive,
    true,
  );
};
export const useGetAgentShareConfig = (data: {}) => {
  return reqPost<{}, GetAgentShareConfigRsp>(
    data,
    NetUserAgent.mod,
    NetUserAgent.GetAgentShareConfig,
    true,
  );
};
export const useTeamCommissionData = (data: {}) => {
  return reqPost<{}, AgencyTeamCommissionData>(
    data,
    NetUserAgent.mod,
    NetUserAgent.TeamCommissionData,
    true,
  );
};
export const useCommissionDetailList = (data: {}) => {
  return reqPost<{}, { list: [] }>(
    data,
    NetUserAgent.mod,
    NetUserAgent.CommissionDetailList,
    true,
  );
};

export const useGetAgencyDayCommissionRecord = (
  data: AgencyDayCommissionRecordReq,
) => {
  return reqPost<AgencyDayCommissionRecordReq, AgencyDayCommissionRecordRsp>(
    data,
    NetUserAgent.mod,
    NetUserAgent.DayCommissionList,
    true,
  );
};

export const useAgencyRewardList = (data: AgencyRewardListReq) => {
  return reqPost<AgencyRewardListReq, AgencyRewardListRsp>(
    data,
    NetUserAgent.mod,
    NetUserAgent.AgencyRewardList,
    true,
  );
};

export const useLockedUserList = (data: AgencyLockUserReq) => {
  return reqPost<AgencyLockUserReq, AgencyLockUserRsp>(
    data,
    NetUserAgent.mod,
    NetUserAgent.LockedUserList,
    true,
  );
};

export const useFriendVipList = (data: AgencyFriendVipReq) => {
  return reqPost<AgencyFriendVipReq, AgencyFriendVipRsp>(
    data,
    NetUserAgent.mod,
    NetUserAgent.FriendVipList,
    true,
  );
};

export const useReceiveAgencyReward = (data: AgencyReceiveRewardReq) => {
  return reqPost<AgencyReceiveRewardReq, AgencyReceiveRewardReq>(
    data,
    NetUserAgent.mod,
    NetUserAgent.ReceiveAgencyReward,
    true,
  );
};

export const getVipPrivilegesActivity = () => {
  return reqPost<unknown, GetVipPrivilegesActivityReq>(
    {},
    NetUserAgent.activityGatewayMode,
    NetUserAgent.GetVipPrivilegesActivity,
    true,
  );
};

export async function GetUserKycStatus() {
  return reqPost<{}, GetUserKycStatusRsp>(
    {},
    NetUserIDRisk.mod,
    NetUserIDRisk.GetUserKycStatus,
    true,
  );
}

/** 获取联盟计划奖励提示 */
export const getAgentRewardRedDotDataApi = () => {
  return reqPost<unknown, GetAgentRewardRedDotDataRsp>(
    {},
    NetUserAgent.activityGatewayMode,
    NetActivity.GetAgentRewardRedDotData,
    true,
  );
};

export const queryReceiveRewardTaskStatus = (task_id: string) => {
  return reqPost<{ task_id: string }, { fin: boolean }>(
    { task_id },
    NetReward.mod,
    NetReward.QueryReceiveRewardTaskStatus,
    true,
  );
};
